export default __webpack_public_path__ + "static/GI-adverse-events-lg@2x-4f310d5c2563ed99dfff7fffdbfe696b.png";